<template>
  <div>
    <div :class="{'has-logo':showLogo}" class="slideBarItem">
      <logo
        v-if="showLogo"
        :user-info="userInfo"
        :collapse="false"
        @userShowModal="$store.state['zsm-user'].sliderUserInfo=true"
      />
      <div style="display: flex;align-items: center;width: 100%;justify-content: center;position: absolute;top: 80px; padding: 23px 0;border-top: 1px solid #F5F6FA;border-bottom: 1px solid  #F5F6FA;">
        <el-button
          style="width:80px;text-align: center;font-size: 12px;padding: 10px 5px;"
          type="primary"
          size="mini"
          @click="$router.replace('/agent/lecturer')"
        >去邀请</el-button>
        <el-button
          style="width: 80px;text-align: center;font-size: 12px;padding: 10px 5px;"
          type="primary"
          size="mini"
          @click="$message.error('暂未开放')"
        >添加讲师</el-button>
        <!--        $router.replace('/agent/lecturer')-->
      </div>
      <el-scrollbar wrap-class="scrollbar-wrapper" style="position: static">

        <el-menu
          :router="true"
          :default-active="activeMenu"
          :collapse="false"
          :background-color="variables.menuBg"
          :text-color="variables.menuText"
          :unique-opened="true"
          :active-text-color="variables.menuActiveText"
          :collapse-transition="true"
          mode="vertical"
        >

          <el-menu-item index="/agent/index" style="padding-left: 17px!important;" @click="activeMenu=''">
            <div>
              <svg-icon v-if="activeMenu!=='/agent'||activeMenu!=='/agent/index'" color="red" icon-class="antFill-pie-chart" />
              <svg-icon v-else icon-class="pie-chart-2-line" />
              <span slot="title">概况</span>
            </div>
          </el-menu-item>
          <el-submenu index="/lecturer">
            <template slot="title">
              <div>
                <svg-icon color="#010101" icon-class="iconPark-application" />
                <span>讲师管理</span>
              </div>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/agent/lecturer/index">讲师列表</el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group>
              <el-menu-item index="/agent/lecturer/order">讲师销售</el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group>
              <el-menu-item index="/agent/lecturer/invite">邀请列表</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <!--  <el-submenu index="/team">
            <template slot="title">
              <div>
                <svg-icon color="#010101" icon-class="st-product" />
                <span>团队管理</span>
              </div>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/agent/salesman">业务员列表</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="/matrix">
            <template slot="title">
              <div>
                <svg-icon color="#010101" icon-class="iconPark-folder-download" />
                <span>矩阵号管理</span></div>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/agent/matrix">商业服务</el-menu-item>
            </el-menu-item-group>
          </el-submenu>-->

          <el-submenu index="income">
            <template slot="title">
              <div>
                <svg-icon color="#010101" icon-class="semiDesign-semi-icons-histogram" />
                <span>收益管理</span>
              </div>
            </template>
            <el-menu-item-group title="">
              <el-menu-item index="/agent/income">收益管理</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="statistics">
            <template slot="title">
              <div>
                <svg-icon color="#010101" icon-class="semiDesign-semi-icons-histogram" />
                <span>统计</span>
              </div>
            </template>
            <el-menu-item-group title="">
              <el-menu-item index="/agent/statistics">订单统计</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="setting">
            <template slot="title">
              <div>
                <svg-icon color="#010101" icon-class="set" />
                <span>设置</span>
              </div>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/agent/setting/account">账号设置</el-menu-item>
            </el-menu-item-group>

          </el-submenu>
        </el-menu>

      </el-scrollbar>

    </div>

  </div>
</template>

<script>
import driverStep from '@/utils/driver'

// import questionInfo from "../question/index.vue"
import {
  mapGetters
} from 'vuex'
import Logo from './agent-logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import {
  getLocalStorage
} from '@/utils/auth.js'
export default {
  components: {
    SidebarItem,
    Logo
  },
  data() {
    return {
      zsmWebUserPermissionDict: [], // 权限列表
      driverStep2: [], // 指引
      // userInfo: '', //用户信息
      sliderUserInfo: false, // 用户信息
      activeIndex: -1 // 默认选中的下标
    }
  },
  computed: {
    userInfo() {
      if (this.$store.state['zsm-user'].userInfo) {
        return JSON.parse(JSON.parse(this.$store.state['zsm-user'].userInfo))
      } else {
        return JSON.parse(JSON.parse(this.$store.state['zsm-user'].userInfo))
      }
    },
    // routerNow() {
    //   return this.$router
    // },
    // ,'userInfo'
    ...mapGetters([
      // 'permission_routes',
      'sidebar', 'mobile'
    ]),
    permission_routes() {
      var routes = []
      routes = this.$router.options.routes.filter((item, index) => {
        if (item.hidden !== true) {
          return item
        }
      })

      return routes
    },
    activeMenu() {
      const route = this.$route
      const {
        meta,
        path
      } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      // return !this.sidebar.opened
    }
  },
  mounted() {
    this.activeIndex = -1
    this.permission_routes.map((item, index) => { // 当前导航地址
      if (item.name == this.$route.name) {
        this.activeIndex = index
      }
    })
    if (!getLocalStorage('zsm_agent_guide')) {
      this.driverStep2 = driverStep // 新手指引
      this.getSettingDict(true)
    } else {
      this.getSettingDict(false)
    }
  },

  methods: {

    // 获取字典内容
    getSettingDict(guide) {
      this.$store.dispatch('zsm-dict/settingDict', 'zsm_web_user_permission_dict').then(info => { // 用户权限内容
        if (info.length > 0) {
          this.getZsmWebUserPermissionDict(info)
        }
      })

      if (guide == true) {
        this.$store.dispatch('zsm-dict/settingDict', 'zsm_web_agent_guide_list').then(info => {
          if (info.length > 0) {
            this.getZsmWebGuideList(info)
          }
        })
      }
    },

    // 获取权限列表
    getZsmWebUserPermissionDict(info) {
      const zsmWebUserPermissionDict = []
      const zsmWebUserPermissionTwoDict = []
      info.map((item, index) => { // 一级菜单
        if (item.treeLevel == 0) {
          zsmWebUserPermissionDict.push(item)
        } else { // 二级菜单
          zsmWebUserPermissionTwoDict.push(item)
        }
      })
      zsmWebUserPermissionDict.map((item, index) => { // 合并数据
        item.list = []
        zsmWebUserPermissionTwoDict.map((twoItem) => {
          if (item.id == twoItem.parentCode) {
            item.list.push(twoItem)
          }
        })
      })
      this.zsmWebUserPermissionDict = zsmWebUserPermissionDict
    },
    getZsmWebGuideList(info) { // 指引
      info.map((guideItem) => {
        this.driverStep2.map((item, index) => {
          if (item.popover.className == guideItem.cssClass) { // 类名一致的话
            item.popover.className = guideItem.dictValue
            item.popover.title = guideItem.description.replace(new RegExp('＜', 'g'), '<').replace(new RegExp('＞', 'g'), '>').replace(new RegExp('＂', 'g'), '"')
            item.popover.description = guideItem.remarks.replace(new RegExp('＜', 'g'), '<').replace(new RegExp('＞', 'g'), '>').replace(new RegExp('＂', 'g'), '"')
            item.popover.position = guideItem.cssClass
          }
        })
      })
      this.$driver.defineSteps(this.driverStep2)
      this.$driver.start()
    },

    // 方法
    start() {
      this.$nextTick(() => {
        this.$driver.defineSteps(this.driverStep2)
        this.$driver.start()
      })
    },
    // 退出
    loginOut() {
      const that = this
      this.$confirm('退出知视猫创作者管理后台?', '提示', {
        confirmButtonText: '立即退出',
        cancelButtonText: '暂不退出',
        type: 'warning'
      }).then(() => {
        that.$store.dispatch('zsm-user/accountLogout', that.userInfo.mobile).then((res) => {
          that.$router.replace('/login')
        })
      }).catch(() => {

      })
    },
    // 通过手机号获取用户信息
    async getByMobile() {
      const userInfo = await getByMobile(this.$store.state['zsm-user'].userMobile)
      userInfo.data.map((item, index) => {
        if (item.platformDict == this.$store.state['zsm-user'].platformCode) {
          this.userInfo = item
        }
      })
    },
    addCourse() {
      this.$router.push('/course/album')
    },
    // 创建抖音
    createTiktok() {
      this.$router.push('/tiktok')
    },
    preViewExamples() {
      this.$store.dispatch('zsm-dict/settingConfig', 'zsm_upload_pc_tutorial').then((info) => {
        this.$store.state['zsm-dict'].examplesImage = info
        this.$store.state['zsm-dict'].examplesModal = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/styles/variable-color.scss";

  .sliderUserInfo::v-deep {

    .el-dialog__footer {
      padding: 0;
      display: flex;
      align-items: center;
      height: 40px;
      background: rgba(22, 24, 35, .02) !important;
    }

    .loginout {
      color: rgba(22, 24, 35, .7);
      text-align: left;
      font-size: 14px;
      width: 200px;
      margin-left: 30px;
      position: relative;
      cursor: pointer;
      height: 40px;
      display: flex;
      align-items: center;
      line-height: 40px;

      img {
        margin-right: 6px;
        width: 16px;
        height: 16px;
      }

    }

    .el-dialog {
      margin-left: 30px;
      margin-top: 110px !important;
    }

    .el-dialog__body {
      padding: 24px 32px;
      padding-top: 0;
    }

    .userInfoB {
      &>div {
        padding-top: 14px;
      }

      div {
        font-family: PingFang SC;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        color: #161823;
        margin-bottom: 8px;
      }

      span {
        font-family: PingFang SC;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        color: #161823;
      }
    }

    .userInfo {
      .userInfoT {
        display: flex;
        width: 100%;
        padding-bottom: 16px;
        border-bottom: 1px solid rgba(22, 24, 35, .06);

        img {
          width: 48px;
          height: 48px;
          margin-right: 8px;
          display: -webkit-box;
          display: flex;
          -webkit-box-align: center;
          align-items: center;
          border-radius: 50%;
        }

        &>div {
          div {
            font-family: PingFang SC;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
            width: 100%;
            color: #161823;
            margin-bottom: 4px;
            position: relative;

          }

          span {
            font-family: PingFang SC;
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: rgba(22, 24, 35, .5);
            margin-bottom: 10px;
          }
        }
      }
    }

  }

  .el-menu::v-deep {

    &>li {
      margin-bottom: 5px;

      i {
        font-size: 16px;
        font-weight: bold;
        position: absolute;
        right: 30px;
      }
    }

    .is-opened {
      .el-submenu__title {
        div {
          border-radius: 8px 8px 0 0;
          background-color: #F5F6FA !important;
        }

      }

      ul {
        ul {
          padding-left: 45px;
          background-color: #F5F6FA !important;
          border-radius: 0 0 8px 8px;
          margin-left: 17px;
          width: 163px !important;

          li {
            padding: 0 !important;
            // padding-left:30px!important;
            width: 113px !important;

            &::after {
              display: none !important;

            }

            background-color: #F5F6FA !important;
          }
        }
      }

    }

    .is-active {
      i {
        @include color_primary(bg_color_primary_dark);//颜色
      }

      &>div {

        &::after {
          content: "";
          display: block;
          width: 4px;
          height: 24px;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          background-color: #fe2c55;
          position: absolute;
          left: 0px;
          top: 50%;
          -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
        }
      }

      ul {
        ul {
          padding-left: 45px;
          background-color: #F5F6FA !important;
          border-radius: 0 0 8px 8px;
          margin-left: 17px;
          width: 163px !important;

          li {
            padding: 0 !important;
            // padding-left:30px!important;
            width: 110px !important;

            &::after {
              display: none !important;

            }

            background-color: #F5F6FA !important;
          }
        }
      }

      .el-submenu__title {
        div {
          border-radius: 8px 8px 0 0;
          background-color: #F5F6FA !important;
        }

        i {
          font-size: 16px;
          font-weight: bold;
        }
      }

    }

  }

  .slideBarItem::v-deep {

    /*position: relative;*/
    background-color: '' !important;
    // top: 48px;
    // padding-top: 190px;
    padding-top: 185px;
    margin-bottom: 100px;
    overflow-y: auto;
    // height: 100vh;
    height: calc(100vh - 70px);
    .el-menu-item {
      min-width: 100px !important;
    }

    svg {
      font-size: 20px;
      color: #010101;
    }

    i {
      font-size: 16px;
      font-weight: bold;
    }

    .el-submenu__title {
      display: flex;
      align-items: center;
      padding-left: 17px !important;
      background-color: '' !important;

      &>div {
        align-items: center;
        display: flex;
        padding: 0 10px;
        width: 100%;
        border-radius: 8px;
        height: 56px;
        line-height: 56px;

        &:hover {
          background-color: #F5F6FA;
        }
      }

      // padding-left: 30px!important;
    }

    .sidebar-logo-container {
      position: absolute;
      height: 80px;
      top: 0px;
      width: 100%;
    }

    &::-webkit-scrollbar {
      width: 0px;
      height: 6px;
      background-color: rgba(240, 240, 240, 1);
    }

    .el-menu-item {
      font-weight: normal !important;
      align-items: center;
      display: flex;

      &:hover {
        background-color: transparent !important;
      }

      &>div {
        align-items: center;
        display: flex;
        padding: 0 10px;
        width: 100%;
        border-radius: 8px;
      }

      // margin: 0 10px;
      svg {
        font-size: 20px;
        color: #010101;
        fill: currentColor;
        margin-top: -1px;
      }

      &.is-active {
        &>div {
          width: 100%;
          background-color: rgba(245, 246, 250, 100) !important;
        }

        position: relative;
        // background-color: rgba(245, 246, 250, 100) !important;
        box-sizing: border-box;
        border-radius: 2px;

        svg {
          margin-top: -1px;
          fill: currentColor;
          color: rgba(255, 77, 109, 100);
        }

        // border-left: 5px solid rgba(255, 77, 109, 100);
        &::after {
          content: "";
          display: block;
          width: 4px;
          height: 24px;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          background-color: #fe2c55;
          position: absolute;
          left: 0px;
          top: 50%;
          -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
        }
      }
    }

    .el-menu-item-group__title {
      display: none;
    }

    .el-menu-item {
      padding-left: 62px !important;
      font-weight: bolder;
      height: 56px;

      &:hover {
        color: #fe2c55 !important;
      }
    }

    .course_tutorial {
      align-items: center;
      font-size: 14px;
      top: 350px;
      height: 30px;
      left: 20px;
      color: #fff;
      position: fixed;
      z-index: 999;

      p {
        margin: 0;
        padding: 0;
        line-height: 1;
      }

      i {
        margin-right: 10px;
        color: #F7EF4C;
        font-size: 22px;
      }
    }
  }
</style>
